export const PANEL_LAYER_TOGGLE = 'panel-layer-toggle';
export const PANEL_VISIBILITY_CHANGED = 'panel-layer-visibility-changed';
export const PANEL_BACKGROUND_CHANGED = 'panel-background-changed';
export const PANEL_BACKGROUND_ORIGIN_CHANGED =
	'panel-background-origin-changed';
export const PANEL_LAYER_UPDATE = 'panel-layer-update';
export const PANEL_EDITOR_CANCEL = 'panel-editor-cancel';
export const PANEL_EDITOR_SAVE = 'panel-editor-save';
export const PANEL_EDITOR_RESET = 'panel-editor-reset';
